import { useState, useEffect } from "react";
import Markdown from "react-markdown";
import introTextPath from "../../static/indexText.md";
import python from "../../static/images/python.png";
import java from "../../static/images/java.png";
import go from "../../static/images/go.png";
import azure from "../../static/images/azure.png";
import k3s from "../../static/images/k3s.png";
import k8s from "../../static/images/k8s.png";
import cpp from "../../static/images/cpp.png";
import githubDark from "../../static/images/github.png";
import sql from "../../static/images/sql.png";
import nosql from "../../static/images/nosql-dark.png";
import kafka from "../../static/images/kafka.png";
import docker from "../../static/images/docker.png";
import node from "../../static/images/node.png";

function HomeText() {
  const [introText, setIntroText] = useState("");

  useEffect(() => {
    fetch(introTextPath)
      .then((res) => res.text())
      .then((introTextRes) => {
        setIntroText(introTextRes);
      });
  });

  return (
    <div className="Home-main-content">
      <Markdown children={introText} />
    </div>
  );
}

function HomeIcons() {
  return (
    <div className="Home-icons">
      <img className="Home-icon" src={python} alt="python" />
      <img className="Home-icon" src={java} alt="java" />
      <img className="Home-icon" src={go} alt="golang" />
      <img className="Home-icon" src={cpp} alt="cpp" />
      <img className="Home-icon" src={node} alt="node" />
      <img className="Home-icon" src={sql} alt="sql" />
      <img className="Home-icon" src={nosql} alt="nosql" />
      <img className="Home-icon" src={kafka} alt="kafka" />
      <img className="Home-icon" src={githubDark} alt="github" />
      <img className="Home-icon" src={docker} alt="docker" />
      <img className="Home-icon" src={azure} alt="azure" />
      <img className="Home-icon" src={k3s} alt="k3s" />
      <img className="Home-icon" src={k8s} alt="k8s" />
    </div>
  );
}

export { HomeIcons, HomeText };
